import e from "@dialpad/dialtone-tokens/layered/themes/tokens-wildflower-colors.css?inline";
//#region themes/wildflower.js
var t = {
	brand: {
		css: e,
		name: "wildflower"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
